import { memo } from "react";
import { Panel } from "primereact/panel";
import { useReport } from "../../context/report";
import ChartQuebras from "./GraficoQuebrasTear";

export default memo(function QuebrasTear() {
    const { handlePrint, data, printing } = useReport();
    return (
        <>
            <Panel header="GRÁFICO DE QUEBRAS TOTAL DE TRAMA POR TEAR" toggleable collapsed={true}>
                <ChartQuebras 
                    data={data} 
                    handlePrint={handlePrint} 
                    index={1} 
                    printing={printing} 
                    producoes={data.producoes} 
                    type="total" 
                />
            </Panel>
            <Panel header="GRÁFICO DE QUEBRAS MÉDIA DE TRAMA POR TEAR" toggleable collapsed={true}>
                <ChartQuebras 
                    data={data} 
                    handlePrint={handlePrint} 
                    index={2} 
                    printing={printing} 
                    producoes={data.producoes} 
                    type="media" 
                />
            </Panel>
        </>
    )
});